<template>
    <div
        class="md-team layout4 mg-bg"
        v-if="allTotal > 0"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            background: bgType === 'color' ? bgColor : ''
        }"
    >
        <div class="layout4-container">
            <site-title
                class="layout4-title f-col"
                :title="fmtTitle"
                :size="48"
                :mbSize="20"
                :align="align"
                v-animated="{name: 'fade-in', duration: 1500, enable: isMobileSize ? false : showAnimationEffects}"
            />
            <template v-if="agents.length">
                <div v-if="!isMobileSize" class="agent-wrap pc-wrap f-col">
                    <div
                        class="agent-item"
                        :class="{'show': !isLess}"
                        v-for="(item, index) in agents"
                        :key="index + item.detailUrl"
                        @click="gotoLink(item.detailUrl)"
                    >
                        <AgentCard
                            :agent="item"
                            :licenseName="licenseName"
                            :detailUrlTarget="detailUrlTarget"
                            :showCalendarLink="enableBookAppointment"
                            :agentBgColor="agentBgColor"
                            :agentDirection="agentDirection"
                            :showAnimationEffects="showAnimationEffects"
                        />
                    </div>
                    <div class="btn-more" v-if="agents.length > 4" @click="toggle">
                        {{ buttonText }}
                    </div>
                </div>

                <swiper v-else v-bind="options" class="mobile-swiper">
                    <slide
                        v-for="(item, index) in agents"
                        :key="index + item.detailUrl"
                    >
                        <div
                            class="agent-item"
                            @click="gotoLink(item.detailUrl)"
                        >
                            <AgentCard
                                :agent="item"
                                :licenseName="licenseName"
                                :detailUrlTarget="detailUrlTarget"
                                :showCalendarLink="enableBookAppointment"
                                :agentBgColor="agentBgColor"
                            />
                        </div>
                    </slide>
                </swiper>
            </template>
        </div>
    </div>
</template>

<script>
import common from '../index';
import carousel from '../carousel';
import AgentCard from './agent-card';
export default {
    mixins: [common, carousel],
    data: function() {
        return {
            // buttonText: 'More',
            curNum: 4,
            isLess: true
        };
    },
    components: {
        AgentCard
    },
    computed: {
        isMoreThanTen() {
            return this.agents.length > 10;
        },
        buttonText() {
            return  this.isLess ? 'More' : 'Less'; 
        }
    },
    methods: {
        toggle() {
            const itemDomList = document.querySelector('.agent-wrap')?.querySelectorAll('.agent-item');
            const itemsLen = itemDomList?.length;

            if (itemsLen <= 10) {
                for (let i = this.curNum; i < itemsLen; i++) {
                    itemDomList[i]?.classList.add('show');
                }
                this.isLess = !this.isLess;
            } else {
                if (this.curNum < 10) {
                    this.isLess = true;
                } else {
                    this.isLess = !this.isLess;
                }
                let nextIndex = this.curNum < 10 ? 10 : itemsLen;
                for (let i = this.curNum; i < nextIndex; i++) {
                    itemDomList[i].classList.add('show');
                }
                this.curNum = nextIndex;
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-team.layout4 {
    .layout4-container {
        .layout4-title {
            word-break: break-word;
            margin-bottom: 40px;
            @include media-800 {
                margin-bottom: 20px;
            }
        }
        .agent-wrap {
            .agent-item {
                width: 100%;
                &:nth-child(n + 5) {
                    display: none;
                }
                &.show {
                    display: block;
                }
                &.showAllAgents {
                    display: block;
                }
            }
            .agent-item + .agent-item {
                margin-top: 40px;
            }
            .btn-more {
                margin-top: 40px;
                text-align: center;
                color: var(--g-text-color);
                font-size: 20px;
                line-height: 1.2;
                font-weight: 400;
                cursor: pointer;
                text-decoration: underline;
            }
        }
        .mobile-swiper {
            height: auto;
            display: flex;
            align-items: stretch;
            .swiper-slide {
                &:first-child {
                    margin-left: 15px;
                }
            }
            .agent-item {
                flex: none;
                align-self: flex-start;
                width: 100%;
                height: auto;
                &:nth-child(n + 5) {
                    display: block;
                }
            }
            .agent-item + .agent-item {
                margin-top: 0;
            }
        }
    }
}
</style>
